export default __webpack_public_path__ + "static/media/earphones3.c068c9c8.jfif";